import { useTranslation } from 'react-i18next';

export function EventsSection() {
  const { t } = useTranslation();
  
  const events = [
    {
      image: 'https://static.readdy.ai/image/efe453aa8b08959c7487fe5d411998a7/3ad52a94ed367fef3d94509495b74bd2.jpeg',
      title: t('events_event1_title'),
      date: t('events_event1_date'),
      description: t('events_event1_desc')
    },
    {
      image: 'https://static.readdy.ai/image/efe453aa8b08959c7487fe5d411998a7/2f35bc730919378fddb47955d9ce0f6f.jpeg',
      title: t('events_event2_title'),
      date: t('events_event2_date'),
      description: t('events_event2_desc')
    }
  ];

  return (
    <section className="py-24 bg-white">
      <div className="container mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
            {t('events_title')}<span className="text-blue-600">{t('events_title_highlight')}</span>
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            {t('events_subtitle')}<strong>{t('events_subtitle_bold')}</strong>{t('events_subtitle_end')}
          </p>
        </div>

        <div className="max-w-5xl mx-auto space-y-12">
          {events.map((event, index) => (
            <div 
              key={index}
              className="bg-gradient-to-br from-gray-50 to-blue-50 rounded-2xl overflow-hidden shadow-xl hover:shadow-2xl transition-all duration-300"
            >
              {/* Event Image */}
              <div className="aspect-[16/9] overflow-hidden">
                <img 
                  src={event.image}
                  alt={event.title}
                  className="w-full h-full object-cover object-top hover:scale-105 transition-transform duration-500"
                />
              </div>
              
              {/* Event Info */}
              <div className="p-8 md:p-12">
                <div className="flex items-center gap-4 mb-4">
                  <div className="w-12 h-12 flex items-center justify-center bg-blue-600 text-white rounded-lg">
                    <i className="ri-calendar-event-line text-2xl"></i>
                  </div>
                  <span className="text-blue-600 font-semibold text-lg">{event.date}</span>
                </div>
                
                <h3 className="text-2xl md:text-3xl font-bold text-gray-900 mb-4">
                  {event.title}
                </h3>
                
                <p className="text-lg text-gray-700 leading-relaxed">
                  {event.description}
                </p>

                <div className="mt-8 flex flex-wrap gap-3">
                  <span className="px-4 py-2 bg-blue-100 text-blue-700 rounded-full text-sm font-medium">
                    <i className="ri-building-line mr-2"></i>
                    {t('events_tag_1')}
                  </span>
                  <span className="px-4 py-2 bg-blue-100 text-blue-700 rounded-full text-sm font-medium">
                    <i className="ri-team-line mr-2"></i>
                    {t('events_tag_2')}
                  </span>
                  <span className="px-4 py-2 bg-blue-100 text-blue-700 rounded-full text-sm font-medium">
                    <i className="ri-global-line mr-2"></i>
                    {t('events_tag_3')}
                  </span>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Additional Info */}
        <div className="mt-16 text-center">
          <div className="inline-flex items-center gap-3 bg-blue-50 px-8 py-4 rounded-full">
            <i className="ri-award-line text-3xl text-blue-600"></i>
            <p className="text-gray-700 font-medium">
              <strong className="text-blue-600">{t('events_tag_1')}</strong>{t('events_member_badge')}
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
